import {useState, useEffect, useRef}        from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {useActionModal}                     from "components/Covers/confirmAction";
import {useInfoMsgModal}                    from "components/Covers/infoMessageModal";
import {useToastMessage}                    from "components/Covers/toastMessage";
import {InputGeneral}                       from "components/Field/field";
import {BtnCloseAction}                     from "components/Buttons/Close/BtnClose";
import MainStyle                            from "components/UI/main.module.scss";
import {getSystemLists,getUserList,getUserByID,updateUser,deleteUser}  from "./usersService";
import { validateEmail, 
         getImgSrc, 
         DefaultLoadingLogo,
         DavidCopperfield,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature }                   from "Utilities/utils";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import { useNavigate }                      from "react-router-dom";
import { Select }                           from "antd";

let blank_user_obj = {
    'USER_ID': 0,
    'EMAIL': "",
    'FIRST_NAME': "",
    'LAST_NAME': "",
    'COMPANY_POSITION_ID': 0,
    'COMPANY_POSITION_DESC': "",
    'SECTOR_ID': 0,
    'SECTOR_DESC': "",
    'RESTRICTED_ACCESS': "Y",
    'RESTRICTED_DATA': "N",
    'STATUS_ID': 1,
    'FILE_ID': 0,
    'FILE_DESC': "",
    'FILE_DATA': ""
};
let appLang = null;

const Avatar = () => {
    return (
        <>
            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_3].join(" ")}> 
                <div 
                    style={{overflowX: 'hidden', overflowY: 'hidden', width: '3rem', height: '3rem'}}
                    className={[MainStyle.border,
                                MainStyle.shadow_sm, 
                                MainStyle.rounded_circle].join(" ")} 
                >
                    <svg viewBox="0 -5 66 66" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: '#f0f0f0', width: '3rem', height: '3rem'}}>
                        <circle className={MainStyle.avatar_head} cx="32" cy="22" r="12" fill="#707070"/>
                        <path d="M32 36c-9 0-20 6-20 14v14h40V50c0-8-11-14-20-14z" fill="#707070"/>
                        <ellipse className={MainStyle.avatar_eye_left} cx="27" cy="20" rx="2" ry="2" fill="#fff"/>
                        <ellipse className={MainStyle.avatar_eye_right} cx="37" cy="20" rx="2" ry="2" fill="#fff"/>
                    </svg>
                </div>
            </div>
        </>
    );
};
/*
const SearchableDropdownList = ({
    className,
    style,
    onChange,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value}) => {
  return (
    <Select
      name={name}
      id={id}
      placeholder={placeholder}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={listOfItems}
      className={className}
      style={style}
      onChange={onChange}
      defaultValue={defaultValue}
      title={title}
      popupClassName={popupClassName}
      value={value}
    />
  );
};
*/
const SearchableDropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};
const SelectDataPopup = ({displayModal, setDisplayModal, objectSet, dataset}) => {
    const [searchString, setSearchString] = useState("");
    const [filteredData, setFilteredData] = useState(dataset);
    const handleSelect = (file_id, file_desc, file_data) => {
        objectSet({ FILE_ID: file_id,
                    FILE_DESC: file_desc, 
                    FILE_DATA: file_data});
        setDisplayModal(false);
    };
    const handleSearchData = (event) => {
        setSearchString(event);
        let temp_arr = dataset.filter((item) =>
            item.FILE_DESC.toLowerCase().includes(event.toLowerCase())
        );
        setFilteredData(temp_arr);
    };
    return (
        <>
        {displayModal === true ?
            <div className={[MainStyle.modal].join(" ")}>
              <div className={[MainStyle.modal_dialog].join(" ")}>
                <div className={[MainStyle.modal_content, MainStyle.rounded_3, MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card, MainStyle.mx_3].join(" ")}>
                  <div className={MainStyle.m_3}>
                    <div className={MainStyle.modal_header}>
                      <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_4, MainStyle.fw_semibold].join(" ")}>
                        {GetLabel(appLang, 347)}
                      </span>
                    </div>
                    <div className={MainStyle.modal_body}>
                        <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_12}>
                                    <InputGeneral 
                                        value={searchString}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => handleSearchData(event.target.value)}
                                        placeholder={GetLabel(appLang, 33)}
                                        maxLength={500}
                                    />
                                </div>
                        </div>



                        <div className={MainStyle.overflow_y_scroll} style={{height: '20rem'}}>

                        
                        {  filteredData !== dataset ?
                            
                            filteredData.length === 0 ?
                                <div className={MainStyle.row}>
                                    <div className={MainStyle.col_lg_12}>
                                        <p className={[  MainStyle.fs_7,
                                                         MainStyle.text_body_faded,
                                                         MainStyle.fw_semibold,
                                                         MainStyle.mt_3,
                                                         MainStyle.text_center
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 220)}
                                        </p>
                                    </div>
                                </div>
                            :
                            filteredData.map((data) => {
                                return (
                                    <div  key={data.FILE_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                         onClick={() => handleSelect(data.FILE_ID, data.FILE_DESC, data.FILE_DATA)}
                                         alt={data.FILE_DESC}
                                    >
                                            <div className={MainStyle.col_lg_11}>
                                                <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{overflowX: 'hidden',
                                                         overflowY: 'hidden',
                                                         width: '5rem', 
                                                         height: '5rem'}}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        <img 
                                                            src={getImgSrc(data.FILE_DATA)} 
                                                            style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                        />
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>{data.FILE_DESC}</p>
                                                </div>
                                            </div>
                                            <div className={MainStyle.col_lg_1}/>
                                    </div>
                                );
                            })
                        :
                            dataset.length > 0 ?                             
                            dataset.map((data) => {
                                return (
                                    <div  key={data.FILE_ID} className={[MainStyle.row, MainStyle.border_top, MainStyle.border_bottom, MainStyle.clickable].join(" ")}
                                         onClick={() => handleSelect(data.FILE_ID, data.FILE_DESC, data.FILE_DATA)}
                                         alt={data.FILE_DESC}
                                    >
                                            <div className={MainStyle.col_lg_11}>
                                                <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                                    <div style={{overflowX: 'hidden',
                                                         overflowY: 'hidden',
                                                         width: '5rem', 
                                                         height: '5rem'}}
                                                         className={[MainStyle.border,
                                                                     MainStyle.shadow, 
                                                                     MainStyle.rounded_circle,
                                                                     MainStyle.my_2].join(" ")}
                                                    >
                                                        <img 
                                                            src={getImgSrc(data.FILE_DATA)} 
                                                            style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}
                                                        />
                                                    </div>
                                                    <p className={[MainStyle.text_body, MainStyle.fs_6, MainStyle.ms_3, MainStyle.mt_3].join(" ")}>{data.FILE_DESC}</p>
                                                </div>
                                            </div>
                                            <div className={MainStyle.col_lg_1}/>
                                    </div>
                                );
                            })
                            :
                            null
                        }
                        </div>
                    </div>
                    <div className={MainStyle.my_3}></div>
                    <div className={MainStyle.row}>
                      <div className={MainStyle.col_lg_7}></div>
                      <div className={MainStyle.col_lg_2}></div>
                      <div className={MainStyle.col_lg_1}></div>
                      <div className={MainStyle.col_lg_2}>
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                              style={{width: '100%'}}
                              className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_6, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                              onClick={() => setDisplayModal(false)}
                            >
                              {GetLabel(appLang, 53)}
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        :
        null
        }
        </>
    );

};

const UserEditPanel = ({setProps, data, sysLists}) => {
    const { showLoader, hideLoader }                            = useLoader();                // Control over the loader
    const { showInfoMessage }                                   = useInfoMsgModal();          // Modal message control 
    const { showActionMessage }                                 = useActionModal();           // Modal message + action control     
    const { showToastMessage  }                                 = useToastMessage();          // Toast message display          
    const [userObj,         setUserObj]                         = useState(blank_user_obj);   // User Object
    const [displayModal,    setDisplayModal]                    = useState(false);
    
    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_user_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };      

    const handleSave = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await updateUser(userObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode === 0) {
                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
                if (userObj.USER_ID === 0) {
                    setProps({ setScreen: 1, data: blank_user_obj });
                }
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        const fetchedData = await deleteUser(userObj.USER_ID);
        if (fetchedData?.status?.statusCode != 0) {
            hideLoader();
            showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
        }
        else {
            setProps({ setScreen: 1, data: blank_user_obj });
        }
    };

    const handleChange = (updatedValues) => {
        setUserObj(prevState => ({
            ...prevState,
            ...updatedValues
        }));
    };

    const BtnSave = () => {
        let message = "";
        if (!userObj.EMAIL || !validateEmail(userObj.EMAIL)) {
            message = `${GetLabel(appLang, 348)} ${userObj.EMAIL} ${GetLabel(appLang, 349)}`;
            showInfoMessage({'header': "Atenção", 'message': message});
        }
        else if (!userObj.FIRST_NAME) {
            message = GetLabel(appLang, 350);
            showInfoMessage({'header': "Atenção", 'message': message});
        }
        else if (userObj.SECTOR_ID === 0) {
            message = GetLabel(appLang, 351);
            showInfoMessage({'header': "Atenção", 'message': message});
        }
        else if (userObj.COMPANY_POSITION_ID === 0) {
            message = GetLabel(appLang, 352);
            showInfoMessage({'header': "Atenção", 'message': message});
        }
        else {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: GetLabel(appLang, 353) },
                { confirm_action: () => handleSave()}
              );
        }
    };

    const BtnDelete = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 354) },
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (user_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getUserByID(user_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode === 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            setUserObj(fetchedData || blank_user_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }
            } 
            catch (error) {
                setUserObj(blank_user_obj);
            }
        };
        if (data?.USER_ID && data.USER_ID !== 0) {
            fetchData(data.USER_ID);
        } 
        else {
            setUserObj(blank_user_obj);
        }
    }, [data]);

    return(
        <>
            <SelectDataPopup displayModal={displayModal} setDisplayModal={setDisplayModal} objectSet={handleChange} dataset={sysLists.IMAGE_LIST}/>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_3}/>

                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_7}>
                            {/*     email addr      */}
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_3}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6,
                                                        MainStyle.text_body,
                                                        MainStyle.fw_semibold
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 355)}*:
                                        </span>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_9}>
                                    <div className={MainStyle.mx_3}>
                                        <InputGeneral 
                                                        value={userObj.EMAIL.toLowerCase()}
                                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                        onChange={(event) => handleChange({ EMAIL: event.target.value.toLowerCase() })}
                                                        placeholder={GetLabel(appLang, 356)}
                                                        maxLength={320}
                                        />
                                        <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{userObj.EMAIL.length} {GetLabel(appLang, 44)} 320 {GetLabel(appLang, 45)}.</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className={[MainStyle.py_2].join(" ")}/>

                            {/*     first name      */}
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_3}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6,
                                                        MainStyle.text_body,
                                                        MainStyle.fw_semibold
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 357)}*:
                                        </span>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_9}>
                                    <div className={MainStyle.mx_3}>
                                        <InputGeneral 
                                                        value={userObj.FIRST_NAME}
                                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                        onChange={(event) => handleChange({ FIRST_NAME: event.target.value })}
                                                        placeholder={GetLabel(appLang, 346)}
                                                        maxLength={50}
                                        />
                                        <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{userObj.FIRST_NAME.length} {GetLabel(appLang, 44)} 50 {GetLabel(appLang, 45)}.</span>
                                    </div>
                                </div>
                            </div>

                            <div className={[MainStyle.py_2].join(" ")}/>

                            {/*     last name      */}
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_3}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6,
                                                        MainStyle.text_body,
                                                        MainStyle.fw_semibold
                                                        ].join(" ")}
                                        >
                                            {GetLabel(appLang, 43)}:
                                        </span>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_9}>
                                    <div className={MainStyle.mx_3}>
                                        <InputGeneral 
                                                        value={userObj.LAST_NAME}
                                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                        onChange={(event) => handleChange({ LAST_NAME: event.target.value })}
                                                        placeholder={GetLabel(appLang, 43)}
                                                        maxLength={150}
                                        />
                                        <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{userObj.LAST_NAME.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                                    </div>
                                </div>
                            </div>

                            <div className={[MainStyle.py_2].join(" ")}/>

                            {/*     Sector      */}
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_3}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6,
                                                          MainStyle.text_body,
                                                          MainStyle.fw_semibold].join(" ")}
                                        >
                                            {GetLabel(appLang, 358)}*:
                                        </span>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_9}>
                                    <div className={MainStyle.mx_3}>
                                        <SearchableDropdownList    
                                            placeholder={GetLabel(appLang, 358)}                                
                                            listOfItems={
                                                sysLists && sysLists.SECTOR_LIST && Array.isArray(sysLists.SECTOR_LIST)
                                                ? 
                                                    sysLists.SECTOR_LIST.map((s) => ({ value: s.SECTOR_ID, label: s.SECTOR_DESC }))
                                                : 
                                                    null
                                            }
                                            style={{ width: "100%" }}  
                                            className={MainStyle.antd_custom_select}                               
                                            popupClassName={MainStyle.antd_custom_select}                              
                                            onChange={(event) => {            
                                                handleChange({ SECTOR_ID: event });
                                            }}
                                            value={userObj.SECTOR_ID > 0 ? parseInt(userObj.SECTOR_ID) : undefined}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={[MainStyle.py_2].join(" ")}/>

                            {/*     Company Position      */}
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_3}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6,
                                                          MainStyle.text_body,
                                                          MainStyle.fw_semibold].join(" ")}
                                        >
                                            {GetLabel(appLang, 359)}*:
                                        </span>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_9}>
                                    <div className={MainStyle.mx_3}>
                                        <SearchableDropdownList    
                                            placeholder={GetLabel(appLang, 359)}                                
                                            listOfItems={
                                                sysLists && sysLists.POSITION_LIST && Array.isArray(sysLists.POSITION_LIST)
                                                ? 
                                                    sysLists.POSITION_LIST.map((p) => ({value: p.COMPANY_POSITION_ID, label: p.COMPANY_POSITION_DESC}))
                                                : 
                                                    null
                                            }
                                            style={{ width: "100%" }}  
                                            className={MainStyle.antd_custom_select}                               
                                            popupClassName={MainStyle.antd_custom_select}                              
                                            onChange={(event) => {
                                                handleChange({ COMPANY_POSITION_ID: event });
                                            }}
                                            value={userObj.COMPANY_POSITION_ID > 0 ? parseInt(userObj.COMPANY_POSITION_ID) : undefined}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={[MainStyle.py_2].join(" ")}/>

                            {/*     Restricted Access      */}
                            <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.align_middle].join(" ")}>
                                <div className={[MainStyle.ms_3].join(" ")}>
                                    <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                        {GetLabel(appLang, 360)}*: 
                                    </span>
                                </div>
                                <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 368)});}}>
                                    <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                        <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                    </svg>
                                </div>
                                <div className={[MainStyle.ps_5, MainStyle.ms_5, MainStyle.justify_content_start].join(" ")}>
                                    <input
                                        type="checkbox"
                                        name={"read"}
                                        checked={userObj.RESTRICTED_ACCESS === "Y" ? true : false}
                                        onChange={()=> {userObj.RESTRICTED_ACCESS === "N"? handleChange({ RESTRICTED_ACCESS: 'Y' }) : handleChange({ RESTRICTED_ACCESS: 'N' })}}
                                        style={{ transform: "scale(1.5)" }}
                                        disabled={false}
                                    />
                                </div>
                            </div>

                            <div className={[MainStyle.py_2].join(" ")}/>

                            {/*     Restricted Data      */}
                            <div className={[MainStyle.d_flex, MainStyle.align_items_center].join(" ")}>
                                    <div className={[MainStyle.ms_3, MainStyle.me_2].join(" ")}>
                                        <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 361)}*: 
                                        </span>
                                    </div>
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 369)});}}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                        </svg>
                                    </div>
                                    <div className={[MainStyle.ps_5, MainStyle.ms_5, MainStyle.justify_content_start].join(" ")}>
                                        <input
                                            type="checkbox"
                                            name={"read"}
                                            checked={userObj.RESTRICTED_DATA === "Y" ? true : false}
                                            onChange={()=> {userObj.RESTRICTED_DATA === "N"? handleChange({ RESTRICTED_DATA: 'Y' }) : handleChange({ RESTRICTED_DATA: 'N' })}}
                                            style={{ transform: "scale(1.5)" }}
                                            disabled={false}
                                        />
                                    </div>
                            </div>

                            <div className={[MainStyle.py_2].join(" ")}/>

                            {/*     Profile photo      */}
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_3}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3, MainStyle.mt_2].join(" ")}>
                                        <span className={[MainStyle.fs_6,
                                                          MainStyle.text_body,
                                                          MainStyle.fw_semibold].join(" ")}
                                        >
                                            {GetLabel(appLang, 362)}:
                                        </span>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_9}>
                                    <div className={MainStyle.mx_3}>
                                        <button
                                            style={{width: '100%'}}
                                            className={[MainStyle.btn_blue, 
                                                        MainStyle.rounded_3, 
                                                        MainStyle.border, 
                                                        MainStyle.shadow_sm, 
                                                        MainStyle.fs_6,
                                                        MainStyle.py_2,
                                                        MainStyle.px_3,
                                                        MainStyle.text_white].join(" ")}
                                            onClick={() => setDisplayModal(true)}
                                        >
                                            {GetLabel(appLang, 363)}
                                        </button>

                                        {
                                            userObj.FILE_ID === 0 || userObj.FILE_ID === null ?
                                                null
                                            :
                                                <div className={MainStyle.mt_3}>
                                                    <button
                                                        style={{width: '100%'}}
                                                        className={[MainStyle.btn_delete, 
                                                                    MainStyle.rounded_3, 
                                                                    MainStyle.border, 
                                                                    MainStyle.shadow_sm, 
                                                                    MainStyle.fs_6,
                                                                    MainStyle.py_2,
                                                                    MainStyle.px_3].join(" ")}
                                                        onClick={() => {
                                                            handleChange({ FILE_ID: 0, FILE_DATA: "", FILE_DESC: ""});
                                                        }}
                                                    >
                                                      {GetLabel(appLang, 364)}  
                                                    </button>
                                                </div>
                                        }                                        
                                    </div>
                                </div>
                            </div>

                            <div className={[MainStyle.py_2].join(" ")}/>

                        </div>
                        <div className={MainStyle.col_lg_4}>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.align_items_center].join(" ")} style={{height: '100%'}}>
                                <div style={{overflowX: 'hidden', overflowY: 'hidden', width: '16rem', height: '16rem'}}
                                     className={[MainStyle.border,MainStyle.shadow_sm, MainStyle.rounded_circle, MainStyle.my_3].join(" ")}
                                >
                                    {userObj.FILE_ID === 0 || userObj.FILE_ID === null ?
                                        <svg viewBox="0 -5 66 66" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: '#f0f0f0', width: '100%', height: '100%'}}>
                                            <circle className={MainStyle.avatar_head} cx="32" cy="22" r="12" fill="#707070"/>
                                            <path d="M32 36c-9 0-20 6-20 14v14h40V50c0-8-11-14-20-14z" fill="#707070"/>
                                            <ellipse className={MainStyle.avatar_eye_left} cx="27" cy="20" rx="2" ry="2" fill="#fff"/>
                                            <ellipse className={MainStyle.avatar_eye_right} cx="37" cy="20" rx="2" ry="2" fill="#fff"/>
                                        </svg>
                                    :
                                        <img src={getImgSrc(userObj.FILE_DATA)}
                                             style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}/>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(1,89,6) && (
                        userObj.USER_ID !== 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={BtnDelete}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(1,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_green, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_3].join(" ")}
                                onClick={BtnSave}
                            >
                                {GetLabel(appLang, 49)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

};

const UsersTableGrid = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  loader
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();          // Grid Ref
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const filePreview = (params) => {
        return (        
            <>
                {params.value != null ? 
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                            <div className={[MainStyle.pt_3, MainStyle.pb_2].join(" ")}>
                                <img
                                    className={[MainStyle.rounded_circle, MainStyle.border, MainStyle.shadow_sm].join(" ")} 
                                    style={{width: '3rem', height: '3rem', objectFit:'cover', objectPosition: '50% 50%'}}  
                                    src={getImgSrc(params.value)}
                                />
                                    
                            </div>
                    </div>
                :
                    <Avatar/>
                }
            </>
        );
    };

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy        = JSON.parse(JSON.stringify(blank_user_obj));
            obj_copy.USER_ID    = props.data.USER_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                    <div 
                        onClick={() => {handleData()}} 
                        className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 512 512"
                            className={[MainStyle.small_ico_generic].join(" ")}
                        >
                            <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                        </svg>
                    </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(1,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),   field: "USER_ID"                    ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "),}    ,    
        { headerName: GetLabel(appLang, 365),  field: "FILE_DATA"                  ,autoHeight: true, flex: 0, headerClass: MainStyle.table_header_center, cellRenderer: filePreview,}    ,
        { headerName: GetLabel(appLang, 366),  field: "FULL_NAME"                  ,filter: true , flex: 0, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 95),   field: "EMAIL"                      ,filter: true , flex: 1, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 268),  field: "SECTOR_DESC"                ,filter: true , flex: 0, cellClass: [MainStyle.table_text_left].join(" ")}    ,
        { headerName: GetLabel(appLang, 127),  field: "COMPANY_POSITION_DESC"      ,filter: true , flex: 0, cellClass: [MainStyle.table_text_left].join(" ")}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData    = await getUserList();
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode === 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            setcolumnDefs(defaultCol);
                            let arr = [];
                            for(var j = 0; j < fetchedData.length; j++) {
                                arr.push(fetchedData[j]);
                            }
                            setRowData(arr);
                            hideLoader();
                            setIsLoading(false);
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};

export const UsersPage = () => {
    const [ screenType,     setScreenType   ]       = useState(1);
    const [ defaultData,    setDefaultData  ]       = useState({});
    const { showActionMessage }                     = useActionModal();
    const [ sysData,        setSysData      ]       = useState({});
    const { showInfoMessage }                       = useInfoMsgModal();          // Modal message control 
    const navigate                                  = useNavigate();    

    const BtnNew = () => {
        handleChange({ setScreen: 2, data: blank_user_obj });
    };

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    useEffect(() => {
        if (!Heimdall([1])) {
            navigate('/home');
            return;
        }
        else {
            SetLastFeature(1);
        }        
        const fetchData = async () => {        
            let sysData = await getSystemLists();
            if (sysData) {
                setSysData(sysData);
            }
        };
        fetchData();
    }, [screenType, defaultData]);

    return (
        <>
        {
        screenType === 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 367)}
                </p>
            </div>
            {DavidCopperfield(1,89,0) && (
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_10}></div>
                    <div className={MainStyle.col_lg_2}>
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnNew}
                            >
                                {GetLabel(appLang, 120)}
                            </button>
                        </div>
                    </div>
                </div>
            )}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                        <UsersTableGrid setProps={handleChange}/>
                    </div>
                </div>
            </div>      
            <div className={MainStyle.pb_3}></div>
        </>
        : 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 367)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <UserEditPanel setProps={handleChange} data={defaultData} sysLists={sysData}/>
            </div>
        </>
        }
        </>
    );
};